import { render, staticRenderFns } from "./modalAmostraIncluida.vue?vue&type=template&id=16285383&scoped=true"
import script from "./modalAmostraIncluida.vue?vue&type=script&lang=js"
export * from "./modalAmostraIncluida.vue?vue&type=script&lang=js"
import style0 from "./modalAmostraIncluida.vue?vue&type=style&index=0&id=16285383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16285383",
  null
  
)

export default component.exports